<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="procSettingTitle" @close="closePopup">
    <el-form slot="content" :model="procInfo" :rules="rules" label-position="top" ref="procInfoForm">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="프로세스 ID" prop="processId">
            <el-input :disabled="isEdit" v-model="procInfo.processId" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="프로세스명" prop="processName">
            <el-input v-model="procInfo.processName" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="명령어 자동 실행" prop="processStopAutostartFlag">
            <el-switch v-model="procInfo.processStopAutostartFlag" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="동작 제어 명령" prop="processCommandStart">
            <span slot="label">
              <span class="mr-r4">동작 제어 명령</span>
              <w-forbidden-command-keyword-legend ref="forbiddenCommandKeywordLegend" />
            </span>
            <el-input type="textarea" v-model="procInfo.processCommandStart" :rows="5" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="정지 제어 명령" prop="processCommandStop">
            <el-input type="textarea" v-model="procInfo.processCommandStop" :rows="5" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="포트 번호" prop="processPort">
            <el-input v-model="procInfo.processPort" placeholder="입력해 주세요."></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" class="mr-r4" @click="saveProcTmplData">저장</el-button>
      <el-button size="large" @click="cancelCommandData">취소</el-button>
    </el-row>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import isNil from 'lodash/isNil';
import clone from 'lodash/clone';
import isUndefined from 'lodash/isUndefined';
import ForbiddenCommandScriptMixin from '@/mixins/forbidden-command-script';

export default {
  name: 'WMajorProcTmplPopup',
  mixins: [ForbiddenCommandScriptMixin],
  props: {
    popupType: String,
    editRow: Object,
    majorProcTypeId: Number,
  },
  data() {
    return {
      isEdit: false,
      formName: 'procInfoForm',
      procSettingTitle: 'test',
      showSearchTool: false,
      params: {
        objId: null,
      },
      procInfo: {
        processId: null,
        processName: null,
        processPort: null,
        processCommandStart: null,
        processCommandStop: null,
        processStopAutostartFlag: null,
      },
      rules: {
        processId: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
        processName: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateNull,
            message: '필수 정보입니다.',
          },
        ],
      },
    };
  },
  watch: {
    editRow: {
      handler(row) {
        this.procInfo = clone(row);
        if (this.popupType === 'ADD') {
          this.isEdit = false;
          this.procSettingTitle = '중요 프로세스 템플릿 추가';
        } else {
          this.isEdit = true;
          this.procSettingTitle = `${row.processName} 정보 수정`;
        }
      },
      deep: true,
    },
  },
  methods: {
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.$refs.slidingPopup.visible = false;
    },
    open() {
      this.$refs.slidingPopup.open();
      this.$emit('open');
    },
    saveProcTmplData() {
      const saveParams = clone(this.procInfo);
      saveParams.majorProcTypeId = this.majorProcTypeId;
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          // 수행금지명령어 확인 로직
          const forbiddenCommandList = this.$refs.forbiddenCommandKeywordLegend.getForbiddenCommandList();
          const scriptContents = `${this.procInfo.processCommandStart} ${this.procInfo.processCommandStop}`;
          if (this.checkForbiddenCommand(forbiddenCommandList, scriptContents)) {
            return;
          }
          if (this.popupType === 'ADD') {
            ServerSettingAPI.insertMajorProcessList(saveParams).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          } else {
            ServerSettingAPI.updateMajorProcess(saveParams).then((response) => {
              if (response.data.success) {
                this.$emit('reload-data');
                this.closePopup();
              }
            });
          }
        } else {
          this.$message(msgUtil.getCustomMsgData('필수사항을 입력해주세요.'));
        }
      });
    },
    validateNull(rule, value, callback) {
      if (isUndefined(value) || value === '' || isNil(value)) {
        callback(new Error());
      } else {
        callback();
      }
    },
    cancelCommandData() {
      this.closePopup();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/ProcessSettings/MajorProcessRegistView/popup/MajorProcTmplPopup.vue